<meta charset="utf-8">

<div class="modal-body">
 <span class="center">CHP Aluche - Area privada</span>
 <ng-container *ngIf="errorMessage">
   <span class="error">{{errorMessage}}</span>
 </ng-container>

 <form [formGroup]="loginForm">
   <div class="form-group">
     <label for="username">Username*</label>
     <input type="text" id="username" placeholder="Username" class="form-control" formControlName="username" />
     <span style="color:Red;" *ngIf="loginForm.controls['username'].touched && loginForm.controls['username'].errors?.required">Username is required.</span>
   </div>

   <div class="form-group">
     <label for="password">Password*</label>
     <input id="password" type="password" placeholder="Password" class="form-control" formControlName="password" />
     <span style="color:Red;" *ngIf="loginForm.controls['password'].touched && loginForm.controls['password'].errors?.required">Password is required.</span>
   </div>

   <div class="buttons-container center">
     <button class="btn btn-primary" (click)="signIn()">Entrar</button>
     <button class="btn btn-primary" (click)="resetPassword()">Reestablecer contraseña</button>
   </div>
 </form>
</div>